// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrappers-wrapper {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-content: center;
	margin-top: 0rem;
	position: relative;
}

.direct-init-error {
	width: 50vw;
	height: 40vh;
	position: absolute;
	top: 30vh;
	left: 25vw;
	z-index: 5003;
	padding: 1rem;
	background-color: rgba(255, 255, 255, 0.9);
	border-radius: 1rem;
	line-height: 2rem;
	filter: drop-shadow(0 0 0.75rem rgba(0, 0, 0, 0.5));
}
.map.leaflet-container {
	/* max-height: 75vh !important; */
	height: 100%;
	width: 100%;
	padding-top: unset;
}
.leaflet-tile-container {
	width: 100vw;
	height: 100vh;
	z-index: 600;
	overflow: visible;
}

#map1 {
	/* width: 100vw;
	height: 100vh; */
	width: 100vw;

	top: 0;
	left: 0;
}
.map-wrapper {
	position: absolute;
	top: 0;
	margin-top: 0rem;
	z-index: 5002;
}

.leaflet-popup-content {
	margin: 1rem !important;
	min-height: 100px;
}
.popup-menu {
	margin: 1rem;
}
.popup-menu ul {
	line-height: 1.6rem;
	font-size: 1.4rem;
	list-style: none;
}
.popup-menu li {
	/* background-color: var(--primary-color1); */
	cursor: pointer;
	color: var(--primary-color1);
}
.popup-menu li:hover {
	font-weight: 2;
	cursor: pointer;
}

@media (min-width: 500px) {
	.map-wrapper {
		/* display: flex;
		flex-direction: row; */
		position: absolute;
		margin-top: 0rem;
		/* width: 100vw;
		height: 90vh; */
		/* align-self: center; */
		top: 0;
	}
	#map1 {
		/* width: 100vw;
		height: 100vh; */
		width: 100vw;
		height: 100vh;
		top: 0;
		left: 0;
	}
}

@media (min-width: 1000px) {
	.map-wrapper {
		/* display: flex;
		flex-direction: row; */
		position: absolute;
		margin-top: 0rem;
		/* width: 100vw;
		height: 90vh; */
	}
	/* .map.leaflet-container {
		height: 100%;
		width: 100%;
	
	} */
	#map1 {
		/* width: 100vw;
		height: 100vh; */
		width: 100vw;
		height: 100vh;
		top: 0;
		left: 0;
	}
}
`, "",{"version":3,"sources":["webpack://./src/styles/MapPage.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,sBAAsB;CACtB,uBAAuB;CACvB,qBAAqB;CACrB,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,SAAS;CACT,UAAU;CACV,aAAa;CACb,aAAa;CACb,0CAA0C;CAC1C,mBAAmB;CACnB,iBAAiB;CACjB,mDAAmD;AACpD;AACA;CACC,iCAAiC;CACjC,YAAY;CACZ,WAAW;CACX,kBAAkB;AACnB;AACA;CACC,YAAY;CACZ,aAAa;CACb,YAAY;CACZ,iBAAiB;AAClB;;AAEA;CACC;iBACgB;CAChB,YAAY;;CAEZ,MAAM;CACN,OAAO;AACR;AACA;CACC,kBAAkB;CAClB,MAAM;CACN,gBAAgB;CAChB,aAAa;AACd;;AAEA;CACC,uBAAuB;CACvB,iBAAiB;AAClB;AACA;CACC,YAAY;AACb;AACA;CACC,mBAAmB;CACnB,iBAAiB;CACjB,gBAAgB;AACjB;AACA;CACC,6CAA6C;CAC7C,eAAe;CACf,4BAA4B;AAC7B;AACA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC;EACC;wBACsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB;iBACe;EACf,wBAAwB;EACxB,MAAM;CACP;CACA;EACC;kBACgB;EAChB,YAAY;EACZ,aAAa;EACb,MAAM;EACN,OAAO;CACR;AACD;;AAEA;CACC;EACC;wBACsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB;iBACe;CAChB;CACA;;;;IAIG;CACH;EACC;kBACgB;EAChB,YAAY;EACZ,aAAa;EACb,MAAM;EACN,OAAO;CACR;AACD","sourcesContent":[".wrappers-wrapper {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-content: center;\n\tmargin-top: 0rem;\n\tposition: relative;\n}\n\n.direct-init-error {\n\twidth: 50vw;\n\theight: 40vh;\n\tposition: absolute;\n\ttop: 30vh;\n\tleft: 25vw;\n\tz-index: 5003;\n\tpadding: 1rem;\n\tbackground-color: rgba(255, 255, 255, 0.9);\n\tborder-radius: 1rem;\n\tline-height: 2rem;\n\tfilter: drop-shadow(0 0 0.75rem rgba(0, 0, 0, 0.5));\n}\n.map.leaflet-container {\n\t/* max-height: 75vh !important; */\n\theight: 100%;\n\twidth: 100%;\n\tpadding-top: unset;\n}\n.leaflet-tile-container {\n\twidth: 100vw;\n\theight: 100vh;\n\tz-index: 600;\n\toverflow: visible;\n}\n\n#map1 {\n\t/* width: 100vw;\n\theight: 100vh; */\n\twidth: 100vw;\n\n\ttop: 0;\n\tleft: 0;\n}\n.map-wrapper {\n\tposition: absolute;\n\ttop: 0;\n\tmargin-top: 0rem;\n\tz-index: 5002;\n}\n\n.leaflet-popup-content {\n\tmargin: 1rem !important;\n\tmin-height: 100px;\n}\n.popup-menu {\n\tmargin: 1rem;\n}\n.popup-menu ul {\n\tline-height: 1.6rem;\n\tfont-size: 1.4rem;\n\tlist-style: none;\n}\n.popup-menu li {\n\t/* background-color: var(--primary-color1); */\n\tcursor: pointer;\n\tcolor: var(--primary-color1);\n}\n.popup-menu li:hover {\n\tfont-weight: 2;\n\tcursor: pointer;\n}\n\n@media (min-width: 500px) {\n\t.map-wrapper {\n\t\t/* display: flex;\n\t\tflex-direction: row; */\n\t\tposition: absolute;\n\t\tmargin-top: 0rem;\n\t\t/* width: 100vw;\n\t\theight: 90vh; */\n\t\t/* align-self: center; */\n\t\ttop: 0;\n\t}\n\t#map1 {\n\t\t/* width: 100vw;\n\t\theight: 100vh; */\n\t\twidth: 100vw;\n\t\theight: 100vh;\n\t\ttop: 0;\n\t\tleft: 0;\n\t}\n}\n\n@media (min-width: 1000px) {\n\t.map-wrapper {\n\t\t/* display: flex;\n\t\tflex-direction: row; */\n\t\tposition: absolute;\n\t\tmargin-top: 0rem;\n\t\t/* width: 100vw;\n\t\theight: 90vh; */\n\t}\n\t/* .map.leaflet-container {\n\t\theight: 100%;\n\t\twidth: 100%;\n\t\n\t} */\n\t#map1 {\n\t\t/* width: 100vw;\n\t\theight: 100vh; */\n\t\twidth: 100vw;\n\t\theight: 100vh;\n\t\ttop: 0;\n\t\tleft: 0;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
